import { toast } from "sonner";
import $api from "@/zapi-frontend/shared/api/axios";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";
import { TChapter } from "@/zapi-frontend/shared/types/projects";
import { convertMarkdownLinksToHtml } from "@/zapi-frontend/utils/markdown";

const saveContent = async (markdown: string, projectId: string, chapterId: string, current?: boolean) => {
  try {
    const response = await $api.put<{ data: TChapter }>(`/projects/${projectId}/chapters/${chapterId}`, {
      memo: markdown,
      current
    });

    if (response.status !== 200) throw new Error("Failed to save content");

    return response.data.data;
  } catch (error) {
    console.error("Error saving content:", error);
    throw error;
  }
};

export const createAutoSaveHandler = (autoSave: boolean, projectId?: string, iAmLeader?: () => boolean) => {
  return async (markdown: string) => {
    if (!autoSave || !projectId) return;
    if (!iAmLeader?.()) return;

    try {
      const { updateChapterContentUpdatedAt, activeChapter } = useChapterStore.getState();
      if (!activeChapter?.id) return;

      // Don't normalize content to preserve raw text exactly as typed
      const updatedChapter = await saveContent(
        convertMarkdownLinksToHtml(markdown),
        projectId,
        activeChapter.id.toString(),
        activeChapter.isCurrent
      );

      if (updatedChapter.activeMemo?.contentUpdatedAt) {
        updateChapterContentUpdatedAt(activeChapter.id.toString(), updatedChapter.activeMemo.contentUpdatedAt);
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
      toast.error("Failed to auto-save content");
    }
  };
};
